import React, { useContext, useEffect, useState } from 'react';
import {
  makeStyles, Box, LinearProgress, Typography,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import { useRecoilValue } from 'recoil';
import AppContext from '../../state/AppContext';
import { fetchStaticToken } from '../../helpers/authentication';
import api from '../../config/api';
import FutureAppointment from './FutureAppointment';
import isLoadingClinicsState from '../../state/apiRequestStatus';
import { jwtTokenState, validatedCustomerState } from '../../state/apiData';

const useStyles = makeStyles(() => ({
  container: {},
}));

const FutureAppointments = () => {
  const classes = useStyles();
  const {
    isLoadingServices,
    isLoadingTherapists,
  } = useContext(AppContext);

  const jwtToken = useRecoilValue(jwtTokenState);
  const validatedCustomer = useRecoilValue(validatedCustomerState);
  const isloadingClinics = useRecoilValue(isLoadingClinicsState);

  const [isLoadingFutureAppointments, setIsLoadingFutureAppointments] = useState(false);
  const [errorFutureAppointments, setErrorFutureAppointments] = useState(false);
  const [futureAppointments, setFutureAppointments] = useState(null);

  const fetchFutureAppointments = async () => {
    setIsLoadingFutureAppointments(true);
    setErrorFutureAppointments(false);

    const responseFutureAppointments = await fetchStaticToken({
      url: api.futureAppointments,
      method: 'POST',
      body: {
        email: validatedCustomer.email,
        customerID: validatedCustomer.customerID,
        jwt: jwtToken,
      },
    });

    if (responseFutureAppointments.status === 200) {
      const responseFutureAppointmentsData = await responseFutureAppointments.json();
      setFutureAppointments(responseFutureAppointmentsData);
      return setIsLoadingFutureAppointments(false);
    }

    setErrorFutureAppointments(true);
    return setIsLoadingFutureAppointments(false);
  };

  useEffect(() => {
    fetchFutureAppointments();
  }, []);

  return (
    <div className={classes.container}>
      <Box mt={3} mb={2}>
        <Typography variant="h3">
          <FormattedMessage id="FutureAppointments.mainTitle" />
        </Typography>
      </Box>
      {errorFutureAppointments
        && (
          <Box mt={3}>
            <Alert severity="error">
              <FormattedMessage id="FutureAppointments.emptyArrayResponse" />
            </Alert>
          </Box>
        )}

      {isLoadingFutureAppointments || isLoadingServices || isLoadingTherapists || isloadingClinics
        ? <LinearProgress />
        : (futureAppointments && futureAppointments.map((futureAppointment) => (
          <FutureAppointment futureAppointment={futureAppointment} key={futureAppointment.id} />)))}
    </div>
  );
};

FutureAppointments.propTypes = {};

export default FutureAppointments;
